module.exports = __webpack_public_path__ + "static/img/方案详情banner.90b549c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/方案详情banner.png
// module id = Iw9j
// module chunks = 0